import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';

export default function MiniCtaSection() {
  const { t } = useTranslation();
  const { lang } = useParams();

  return (
    <section className="py-16 md:py-20 bg-[#06121F]">
      <div className="max-w-3xl mx-auto px-6 text-center">
        {/* 見出し */}
        <h2 className="text-2xl md:text-3xl font-serif text-white/90 tracking-wide mb-10">
          {t('miniCta.heading')}
        </h2>

        {/* CTA ボタン（v0.8.0 で変更：Primary は /story へ） */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          {/* Primary: GREAT HERO'S JOURNEYとは */}
          <Link
            to={`/${lang}/story`}
            className="inline-flex items-center justify-center rounded-full px-8 py-3 transition backdrop-blur-sm border border-white/60 text-white/90 hover:bg-white/15 hover:border-white/80"
          >
            {t('miniCta.story')}
          </Link>
          {/* Secondary: お問い合わせ */}
          <Link
            to={`/${lang}/contact`}
            className="inline-flex items-center justify-center rounded-full px-6 py-3 transition backdrop-blur-sm border border-white/30 text-white/80 hover:bg-white/5"
          >
            {t('miniCta.contact')}
          </Link>
        </div>
      </div>
    </section>
  );
}
